<template>
  <div>
    <el-form
        ref="form"
        :model="param"
        label-width="100px"
        label-position="left"
      >
        <el-form-item label="位置区域" prop="type">
          <el-select ref="select" style="width:100%" v-model="param.space" placeholder="请选择">
            <el-option
                key=""
              label=""
            value=""
              style="display: none;">
            </el-option>
            <el-tree :data="data" style="width: 100%;height: 100%;" :props="defaultProps" @node-click="handleNodeClick">
              </el-tree>
          </el-select>
        </el-form-item>
      </el-form>
  </div>
</template>

<script>
import {url} from '@/utils/config'
import {postFun} from '@/utils/httpFun'

export default {
  props:{
    edits:{
      type:Object,
      default:()=>{}
    },
    spaceList:{
      type:Array,
      default: () => []
    },
    device:{
      type:Object,
      default: () => {}
    }
  },
  data(){
    return{
      param:{
        space:{}
      },
      data:{},
      spaceObj:{},
      defaultProps: {
        children: 'children',
        label: 'showName'
      },
    }
  },
  mounted() {
    this.data = this.spaceList
  },
  methods:{
    handleNodeClick(e){
      console.log("测试",e)
      this.param.space = e.showName;
      this.spaceObj = e;
      this.$refs.select.blur()
    },
    async edit(){
      if(this.param.space == '' || this.param.space == undefined || this.param.space == null ){
        this.$message.warning("未选择区域");
        return;
      }
      console.log("编辑",this.edits,this.spaceObj,this.device)

      let arr = [];
      arr.push(this.edits.areaAddress);
      arr.push(this.edits.address);
      let str = arr.join(",") + '-'+this.spaceObj.showName
      // arr.push(this.spaceObj.showName);

      let param = {
        'address':str,
        'deviceTypeId':this.device.deviceTypeId,
        'deviceId':this.device.deviceId,
        'spaceId':this.spaceObj.id
      }

      await postFun(url.PROJECT.UPDATESPACE,param,res=>{
        console.log("编辑",res)
        if(res.data){
          this.$message.success("编辑成功");
        }else{
          this.$message.warning("编辑失败");
        }
        this.$bus.$emit('device-getData')
        // this.$parent.getDatas()
        this.$emit('Close')
      })
    }
  }
}
</script>

<style>

</style>